<template>
  <ul class="table__row">
    <li v-for="(item, idx) in row" :key="data.groupName + idx" class="table__col">
      <p class="table__text">{{ data[item] }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['data', 'row']
};
</script>
